export default "__VITE_ASSET__zbztRfxB__"